import { Link, useLoaderData, data } from "react-router";
// import { getSession } from "~/.server/supabase";
import { Route } from "./+types/route";

export async function loader({ request }: Route.LoaderArgs) {
  // const { user, headers } = await getSession(request);
  return data(
    {
      // user,
      version: process.env.VERSION,
    },
    {
      // headers,
    },
  );
}

export default function Index({ loaderData }: Route.ComponentProps) {
  const { version } = loaderData;
  // const isLogged = user !== null;
  return (
    <div className="w-screen h-screen flex flex-col">
      <div className="navbar bg-base-100">
        <div className="indicator">
          <span className="indicator-item indicator-bottom badge badge-primary">
            beta
          </span>
          <Link to="/" className="btn btn-ghost text-xl">
            <div className="avatar">
              <div className="w-10 rounded-xl">
                <img src="/navbar-logo.png" />
              </div>
            </div>
            ReadType
          </Link>
        </div>
        <div className="flex-1"></div>
        <div className="flex-none">
          <div className="container mx-auto flex items-center px-4">
            {/* {isLogged ? (
              <p>
                {user?.email} {" | "} <Link to="/logout">Logout</Link>
              </p>
            ) : (
              <Link to="/login">Login</Link>
            )} */}
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col bg-base-200">
        <div className="h-96 flex items-center justify-center">
          <div className="hero">
            <div className="hero-content text-center">
              <div className="max-w-xl">
                <h1 className="text-4xl font-bold">Read your book by typing</h1>
                <p className="py-6">
                  Improve your understanding and memorization by typing the book
                  you read. ReadType will help you to type the book you read to
                  make reading more fun.
                </p>
                <Link to="/app" className="btn btn-primary">
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 justify-items-center my-8">
          <div className="px-4 h-full">
            <div className="card bg-base-100 w-full h-full shadow-xl">
              <figure>
                <img src="/typing-experience.png" alt="Typing Experience" />
              </figure>
              <div className="card-body">
                <h2 className="card-title">Familiar interface</h2>
                <p>
                  Heavily inspired by other typing tools makes it easy to use
                </p>
              </div>
            </div>
          </div>
          <div className="px-4 h-full">
            <div className="card bg-base-100 w-full h-full shadow-xl">
              <figure>
                <img src="/simple-control.png" alt="Simple Typing Control" />
              </figure>
              <div className="card-body">
                <h2 className="card-title">Simple</h2>
                <p>
                  Typing experience tailored for reading while typing, without
                  any complexity like typing symbol.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="footer footer-center bg-base-300 text-base-content p-4">
        <aside>
          <p>
            Copyright © {new Date().getFullYear()} - All right reserved by{" "}
            <Link to="https://dirathea.com">dirathea</Link> - Version:{" "}
            {version?.substring(0, 10)}
          </p>
        </aside>
      </footer>
    </div>
  );
}
